module.exports = __webpack_public_path__ + "assets/retina_CircleTangentCLDetailed.654500784465390216bf83a999573ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleTangentCLDetailed.png
// module id = 646
// module chunks = 0